"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Back4app2Error_1 = require("./Back4app2Error");
/**
 * The schema diff could not be computed for a DETERMINISTIC reason — the
 * diff engine ran and refused/failed (invalid DDL, unsupported operation,
 * bad credentials on the target). Retrying would fail identically.
 *
 * Deliberately distinct from `NetworkError` / `TimeoutError`, which the
 * publish drawer DOES retry. This one carries the underlying reason so the
 * drawer can show the user what actually went wrong instead of a generic
 * "try again" it knows won't help.
 */
var SchemaPreviewError = /** @class */ (function (_super) {
    __extends(SchemaPreviewError, _super);
    function SchemaPreviewError(message) {
        var _this = _super.call(this, message, SchemaPreviewError.CODE) || this;
        Object.setPrototypeOf(_this, SchemaPreviewError.prototype);
        return _this;
    }
    SchemaPreviewError.CODE = 'SCHEMA_PREVIEW_ERROR';
    return SchemaPreviewError;
}(Back4app2Error_1.default));
exports.default = SchemaPreviewError;
